import React from 'react'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing/index'
import ContentSectionHeader from '../../../components/ContentSectionHeader/index'
import createModelNormaliser from '../../../../lib/model/model-to-vehicle-card-normaliser'
import normaliseUsedVehicleForVehicleCard from '../../../../lib/cars/used/used-vehicle-to-card-normaliser'
import FullWidthArticleWidget from '../../../components/FullWidthArticleWidget'

const VehicleCarouselWidget = ({
  header,
  models,
  allModels,
  usedVehicles,
  filter,
  pageType
}) => {
  let normalisedVehicles
  if (models.length > 0) {
    normalisedVehicles = models
      .filter((model) => model && Object.keys(model).length > 0)
      .map((model) => {
        const normaliseModelForVehicleCard = createModelNormaliser(
          model.make,
          allModels
        )
        return normaliseModelForVehicleCard(model)
      })
  } else {
    normalisedVehicles = usedVehicles.map(normaliseUsedVehicleForVehicleCard)
  }

  if (normalisedVehicles.length === 0) return null

  const VehicleCarouselWidgetContent = () => (
    <div>
      {header && <ContentSectionHeader title={header} fg="#1E4F67" />}
      <ContentVehicleMultiCardListing
        vehicles={normalisedVehicles}
        max={3}
        buttons={false}
        loop={false}
        highlightMotability={filter === 'motability'}
      />
    </div>
  )

  return pageType === 'article' ? (
    <FullWidthArticleWidget>
      <VehicleCarouselWidgetContent />
    </FullWidthArticleWidget>
  ) : (
    <VehicleCarouselWidgetContent />
  )
}

export default VehicleCarouselWidget
